import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';
import { AnalyticsService } from 'src/app/service/analytics.service';
import { SeoService } from 'src/app/service/seo.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})
export class ContactComponent implements OnInit {
  Images = IMAGES
  SupportEmail = SUPPORT_EMAIL;
  ContactPhone = '+91 95792 92320';
  ContactPhoneHref = 'tel:+919579292320';

  constructor(private analytics: AnalyticsService, private seoService: SeoService) { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.seoService.addJsonLdSchema({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      'name': 'Varroc Connect',
      'image': 'https://varrocconnect.com/assets/images/websitev2/varroc-connect-logo.png',
      '@id': '',
      'url': 'https://varrocconnect.com/',
      'telephone': '+919579292320',
      'email': 'vc.support@varroc.com',
      'address': {
        '@type': 'PostalAddress',
        'streetAddress': 'Elpro International, Chinchwad Station Rd, Chinchwad Gaon',
        'addressLocality': 'Pimpri-Chinchwad',
        'postalCode': '411033',
        'addressCountry': 'IN'
      },
      'geo': {
        '@type': 'GeoCoordinates',
        'latitude': 18.631524433908417,
        'longitude': 73.78545709533091
      },
      'sameAs': [
        'https://www.facebook.com/varrocconnect/',
        'https://x.com/varrocconnect',
        'https://www.instagram.com/varroc_connect',
        'https://www.linkedin.com/company/varrocconnect/'
      ]
    }, 'jsonld-localbusiness');


  }

  ctaEvent(event_name: string, event_label: string, userId?: string) {
    this.analytics.trackUserInteraction(event_name, event_label, userId || 'guest');
  }


}
